module.exports = __webpack_public_path__ + "img/app/extApp/img/icon-arrow-click-rg.6ba5114127f9153876c808efaa37c457.png";